import { matchPath } from 'react-router'

const FLAG_KEY = 'tanstack_router_shell'
const SHIFTS_ROUTE_NAME = 'shifts'

/**
 * Pre-mount toggle for the TanStack Router coexistence shell.
 *
 * Read synchronously before render: account/partner feature toggles load only after
 * the app boots, inside the router this decides. URL param wins (one-off QA override),
 * then localStorage (sticky per browser). Without either override, match the current path
 * against the route catalog injected by apps/ipp. Only a direct load of the
 * native retailer-scoped Shifts route enables the shell; other initial routes stay legacy.
 */
export function isTanstackShellEnabled(routeCatalog?: Readonly<Record<string, string>>): boolean {
  if (typeof window === 'undefined') return false

  const param = new URLSearchParams(window.location.search).get(FLAG_KEY)
  if (param === '1' || param === 'true') return true
  if (param === '0' || param === 'false') return false

  try {
    const storedFlag = window.localStorage.getItem(FLAG_KEY)
    if (storedFlag === '1') return true
    if (storedFlag === '0' || storedFlag === 'false') return false
  } catch {
    // Storage can be unavailable; route-catalog activation must still work.
  }

  const shiftsPattern = routeCatalog?.[SHIFTS_ROUTE_NAME]
  return Boolean(
    shiftsPattern && matchPath(window.location.pathname, { path: shiftsPattern, exact: true })
  )
}
